export enum EAdBannerSize {
  Tall = 'tall',
  Square = 'square',
  Wide = 'wide',
  Small = 'small',
}

export type AdBannerInstance = {
  startIndex?: number;
  fixed?: boolean;
};

export type AdBannerConfig = {
  image: string;
  link: string | null;
  durationMs: number;
  alt?: string;
  /**
   * If set, this banner only shows when the AdBanner's `route` prop matches one of these values.
   * If omitted or empty, the banner shows on all routes.
   */
  routes?: string[];
};

export type AdBannerProps = {
  size: EAdBannerSize;
  /** Override the default alt text for all banners in this slot */
  alt?: string;
  /** Fallback placeholder text when image fails to load */
  text?: string;
  backgroundColor?: string;
  textColor?: string;
  customSize?: { width: number; height: number };
  hideAtWidth?: number;
  hideAtHeight?: number;
  className?: string;
  /**
   * Start at a specific index in the banner rotation.
   * Useful when rendering two instances of the same slot simultaneously
   * so they don't show the same banner at the same time.
   * e.g. startIndex={1} for the second instance.
   */
  startIndex?: number;
  /** If true, stays fixed at startIndex — never rotates. */
  fixed?: boolean;
  /** Maps to a named instance in banners.json `instances`, overrides startIndex and fixed. */
  instanceId?: string;
  hideMobile?: boolean;
};

export const sizeMap: Record<EAdBannerSize, { width: number; height: number }> =
  {
    [EAdBannerSize.Tall]: { width: 160, height: 600 },
    [EAdBannerSize.Square]: { width: 200, height: 200 },
    [EAdBannerSize.Wide]: { width: 970, height: 90 },
    [EAdBannerSize.Small]: { width: 350, height: 50 },
  };
